import React, { useMemo } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import _ from 'lodash';

import initializeStore from '@/app-state/store';
import { MaintenanceBannerProvider } from '@/context/maintenance-banner';

import { getMaintenanceBannerProp } from './get-global-settings-props';
import hydrateFiltersStateFromUrl from './hydrate-filters-state-from-url';
import { hydrateVehicleIdsStateFromUrl } from './hydrate-vehicle-ids-state';
import { redirectToLowercaseUrl } from './redirect-to-lowercase-url';

const checkServer = () => {
  return typeof window === 'undefined';
};

const __NEXT_REDUX_STORE__ = '__NEXT_REDUX_STORE__';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'initialState' implicitly has an 'any' type.
const getOrCreateStore = (initialState) => {
  // Always make a new store if server, otherwise state is shared between requests
  if (checkServer()) {
    return initializeStore(initialState);
  }

  // Create store if unavailable on the client and set it on the window object
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because index expression is not of type 'number'.
  if (!window[__NEXT_REDUX_STORE__]) {
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because index expression is not of type 'number'.
    window[__NEXT_REDUX_STORE__] = initializeStore(initialState);
  }
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because index expression is not of type 'number'.
  return window[__NEXT_REDUX_STORE__];
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'getPageProps' implicitly has an 'any' type.
export const withAppProps = (getPageProps) => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'ctx' implicitly has an 'any' type.
  return async (ctx) => {
    // Get or Create the store with `undefined` as initialState
    // This allows you to set a custom default initialState
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Expected 1 arguments, but got 0.
    const reduxStore = getOrCreateStore();

    let redirect = null;

    if (_.includes(ctx.resolvedUrl, 'results')) {
      hydrateFiltersStateFromUrl(ctx.query, reduxStore.dispatch.filters);
    }

    if (ctx.query?.vehicles) {
      hydrateVehicleIdsStateFromUrl(ctx.query, reduxStore.dispatch.compare);
    }

    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Expected 1 arguments, but got 2.
    redirect = redirectToLowercaseUrl(ctx?.resolvedUrl, ctx?.res);

    const pageData = (await getPageProps?.(ctx)) ?? { props: {} };

    if (redirect) {
      return {
        redirect: { destination: redirect, permanent: true },
      };
    }

    const { res } = ctx;
    if (res && !res._headerSent && !res.getHeader('cache-control')) {
      // If no cache headers set, cache responses for 30 seconds at the CDN level serve cached version whilst revalidating
      // https://zeit.co/blog/serverless-pre-rendering
      res.setHeader('cache-control', 's-maxage=30, stale-while-revalidate=86400, stale-if-error=86400');
    }

    // Banner is non-critical: a Sanity outage should degrade silently to no banner
    // rather than 500 every Pages Router request via a thrown getStaticProps.
    let maintenanceBanner = null;
    if ('props' in pageData) {
      try {
        ({ maintenanceBanner } = await getMaintenanceBannerProp());
      } catch (err) {
        console.error('Failed to fetch maintenance banner; falling back to disabled', err);
      }
    }

    return {
      ...pageData,
      props: {
        ...pageData.props,
        initialReduxState: reduxStore.getState(),
        maintenanceBanner,
      },
    };
  };
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'Component' implicitly has an 'any' type.
// eslint-disable-next-line react/display-name
export const withAppProviders = (Component) => (props) => {
  const { initialReduxState, maintenanceBanner = null, ...pageProps } = props;
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Expected 2 arguments, but got 1.
  const reduxStore = useMemo(() => getOrCreateStore(initialReduxState));

  return (
    <ReduxProvider store={reduxStore}>
      <MaintenanceBannerProvider value={maintenanceBanner}>
        <Component {...pageProps} />
      </MaintenanceBannerProvider>
    </ReduxProvider>
  );
};
